// Modules
import React from 'react';

import { PageContent } from 'components/page';
import PeopleTable from 'components/models/person/people-table';
import Person from 'services/data/person';

import * as actions from '../store/actions';

export default function CompanyPeople({ id }) {
  const { data: people } = actions.useCompanyPeople(id);

  if (!people) return null;

  const ordered = Person.sortPeople(people);

  return (
    <PageContent>
      <PeopleTable people={ordered} update={() => {}} checkable={false} />
    </PageContent>
  );
}



// WEBPACK FOOTER //
// ./app/routes/company/sub-routes/company-people.js